import querystring from 'querystring';
import { useLocation, useHistory } from 'react-router-dom';

export const useCurrencyFromURL = (availableCurrencies) => {
  const { search, pathname } = useLocation();
  const { replace } = useHistory();
  const params = querystring.parse(search.substr(1));

  const changeCurrency = (currency) => {
    const nextParams = new URLSearchParams(search);
    nextParams.set('currency', currency);
    replace(`${pathname}?${nextParams}`);
  };

  if (params.currency) {
    return [params.currency, changeCurrency, { hasAgentChangedCurrency: true }];
  }

  return [availableCurrencies[0], changeCurrency, { hasAgentChangedCurrency: false }];
};

export const useDefaultedCurrencyFromURL = ({ availableCurrencies, defaultCurrency, isMultiCurrency }) => {
  const [currency, changeCurrency, { hasAgentChangedCurrency }] = useCurrencyFromURL(availableCurrencies);

  const agentHasMultipleCurrencies = availableCurrencies.length > 1;

  const shouldUseBookingCurrency = agentHasMultipleCurrencies && !hasAgentChangedCurrency && !isMultiCurrency;

  if (shouldUseBookingCurrency) {
    return [defaultCurrency, changeCurrency];
  }

  return [currency, changeCurrency];
};
